export default class Modal {
  constructor(params) {
    this.props = params;
    this.triggerClass = params?.triggerClass;
    this.triggers = document.querySelectorAll(this.triggerClass)
    this.body = document.querySelector('body')
    this.currentTrigger = null;
    this.currentModal = null;
    this.opening = false;
    this.closing = false;

    this.init();
  }

  init() {
    this.setTrigger();
    this.afterInit();
  }

  afterCloseModal() {
    this.closing = false;
  }

  closeModal() {
    this.currentModal?.classList.remove('is-open');
    this.body.classList.remove('no-scroll', 'is-modal-open');

    setTimeout(() => {
      this.afterCloseModal();
    }, 200);
  }

  beforeCloseModal() {
    this.closeModal()
  }

  afterOpenModal() {
    this.opening = false;
  }

  openModal() {
    this.currentModal.classList.add('is-open');
    this.body.classList.add('no-scroll', 'is-modal-open');
    this.afterOpenModal();
  }

  beforeOpenModal() {
    this.openModal();
  }

  afterInit() {
  }

  setTrigger() {
    this.triggers.forEach((trigger) => {
      const contentsId = trigger.dataset.modalId;
      const targetModal = document.getElementById(contentsId);
      const closeBtn = targetModal.querySelector('.modal-close');
      const targetModalBg = targetModal.querySelector('.modal-bg');

      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        if (this.closing || this.opening) return false;
        this.opening = true;

        this.currentTrigger = trigger;
        this.currentModal = targetModal;
        this.beforeOpenModal();
      });

      closeBtn?.addEventListener('click', () => {
        if (this.closing || this.opening) return false;
        this.closing = true;
        this.beforeCloseModal();
      });

      targetModalBg?.addEventListener('click', () => {
        if (this.closing || this.opening) return false;
        this.closing = true;
        this.beforeCloseModal();
      });
    })
  }

  setTriggerAfter(els) {
    this.triggers = els;
    this.setTrigger();
  }
}